import Helper from '@/helpers/helper'

/**
 * Navigation Guard
 * This will check or run function every route or navigating
 * @param {Object} to  
 * @param {Object} from  
 * @param {function} next  
 * @param {Object} store
 */
export default function navguard ({to, from, next, store}) {
    const isonline = store.state.isonline;
    
    /**
     * Get route from and save to store 
     */
    store.commit('updateroutefrom', from);
    /**
     * Check if has session or expired 
     * if expired delete cookie token
     */
    Helper.checksession()
        .then(() => {
            store.commit('updateloginstatus', true);

            if(to.name == 'login') {
                next({name : 'home'}); 
            } else {
                next();
            }
        })
        .catch(() => {
            if(isonline) {
                store.commit('updateloginstatus', false);
                Helper.deleteCookie('holeswebtoken');
    
                /**
                 * Check if route that trying to access are allowed or not when not logged in
                 */
                const notAllowed = [
                    'ordersubscription',
                    'orderforevent',
                    'checkout', 
                    'payment', 
                    'ordereventschedule', 
                    'product', 
                    'orderschedule'
                ]
    
                if(notAllowed.includes(to.name)) {
                    next({name : 'login'}); 
                } else {
                    next();
                }
            }
        })

    

}